module.exports = __webpack_public_path__ + "img/angakat-barbel.bd804de0.png";